module.exports = __webpack_public_path__ + "static/media/Metanoia Africa.b1c16e2e.png";